import { Button } from "@/components/ui/button";
import { ImagePlus, Link2, BarChart3 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface PostToolbarProps {
  onImageClick: () => void;
  onLinkClick: () => void;
  onPollClick: () => void;
  onGifClick: () => void;
  hasImages: boolean;
  hasPoll: boolean;
  hasGif: boolean;
  disabled?: boolean;
}

export function PostToolbar({
  onImageClick,
  onLinkClick,
  onPollClick,
  onGifClick,
  hasImages,
  hasPoll,
  hasGif,
  disabled
}: PostToolbarProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <div className="flex items-center gap-1 pt-2 border-t border-border/50">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={onImageClick}
              disabled={disabled || hasGif}
              className={`h-8 w-8 p-0 ${hasImages ? 'text-primary' : 'text-muted-foreground'}`}
            >
              <ImagePlus className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Adicionar imagens (até 4)</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={onPollClick}
              disabled={disabled || hasImages || hasGif}
              className={`h-8 w-8 p-0 ${hasPoll ? 'text-primary' : 'text-muted-foreground'}`}
            >
              <BarChart3 className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Criar enquete</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={onGifClick}
              disabled={disabled || hasImages || hasPoll}
              className={`h-8 px-1.5 ${hasGif ? 'text-primary' : 'text-muted-foreground'}`}
            >
              <span className="text-[10px] font-bold leading-none border border-current rounded px-1 py-0.5">GIF</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>Adicionar GIF</TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
